import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { ManageJIT, GetJit, DeleteJOT, EditJit } from "./actions";

const JoinOurTeam = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    email: Yup.string().trim().required("required"),
    message: Yup.string().trim().required("required"),
    phone: Yup.string().trim().required("required"),
    complete_name: Yup.string().trim().required("required"),
    cv: Yup.string().trim().required("required"),
  });

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetJit({
        rowsPerPage,
        page,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setTotalData(data?.count);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    if (array.length == 0) {
      setarray([
        {
          failed: "id",
          type: inputType.text,
          title: "id",
          placeholder: "",
          fullwidth: true,
          customdesign: { display: "none" },
        },
        {
          failed: "complete_name",
          type: inputType.text,
          title: "Complete Name",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "phone",
          type: inputType.text,
          title: "Phone",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "message",
          type: inputType.text,
          title: "Message",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "email",
          type: inputType.text,
          title: "Email",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "cv",
          type: inputType.image,
          title: "CV",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
      ]);
    }
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "complete_name" },
    { type: columntype.text, name: "phone" },
    { type: columntype.text, name: "message" },
    { type: columntype.text, name: "email" },
    { type: columntype.vid, name: "cv" },
    // { type: columntype.switch, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "complete_name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      withSort: false,
    },
    {
      id: "phone",
      numeric: false,
      disablePadding: false,
      label: "Phone",
      withSort: false,
    },
    {
      id: "message",
      numeric: false,
      disablePadding: false,
      label: "Message",
      withSort: false,
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "Email",
      withSort: false,
    },
    {
      id: "cv",
      numeric: false,
      disablePadding: false,
      label: "CV",
      withSort: true,
    },
    // {
    //   id: "is_active",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Is active",
    //   withSort: true,
    // },
    (dataPrivileges["31"]?.access_edit == 1 ||
      dataPrivileges["31"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["31"]?.access_delete === 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${
              row?.complete_name ?? row?.email ?? "this item"
            }?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteJOT({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: row.id,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    // dataPrivileges["31"]?.access_edit === 1 && {
    //   name: "Edit",
    //   function: async (data) => {
    //     setEditMode(true);
    //     setvalues(data);
    //     setShowModal(true);
    //   },
    // },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditJit({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(JR_ID) => {
          console.log({ JR_ID_onPressDelete: JR_ID });
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () => {
                  console.log({ JR_ID_onPressDelete: JR_ID });
                  dispatch(
                    DeleteJOT({
                      id: JR_ID,
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                    })
                  );
                },

                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["31"]?.access_write === 1}
        withDeleteItem={dataPrivileges["31"]?.access_delete === 1}
        withEditItem={dataPrivileges["31"]?.access_edit === 1}
        withPagination={true}
        withSearch={false}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Requests"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new Join Request"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            dispatch(
              ManageJIT({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default JoinOurTeam;
